import WarningIcon from '@mui/icons-material/Warning';
import {DialogActions, Typography, DialogContent} from '@mui/material';
import {Link} from 'react-router-dom';

import {APP_ROUTES} from '../../../const';
import usePayment from '../../../hooks/providers/usePayment';
import useProjects from '../../../hooks/providers/useProjects';
import ContactEmailsList from '../../contact/ContactEmailsList/ContactEmailsList';
import UpgradeSubscriptionEmailsList from '../../contact/UpgradeSubscriptionEmailsList/UpgradeSubcriptionEmailsList';
import Button from '../../form/buttons/Button/Button';
import BaseModal from '../../modal/BaseModal';

const MaximumNumberOfProjectsModal = () => {
  const {maximumNumberOfProjectsReachedModalOpen: isOpen, setMaximumNumberOfProjectsReachedModalOpen: setIsOpen} = useProjects();
  const {isPartner} = usePayment();

  const resetState = () => {
    setIsOpen(false);
  };

  return (
    <BaseModal title="Limite de connexions atteinte" onClose={resetState} open={isOpen}>
      <DialogContent sx={{pb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
        <WarningIcon sx={{fontSize: 120, mb: 3}} color="warning" />
        <Typography fontWeight="bold">Vous avez atteint la limite de connexions que vous pouvez créer.</Typography>
        <br />

        {isPartner ? (
          <UpgradeSubscriptionEmailsList />
        ) : (
          <Typography>
            Pour pouvoir créer plus de connexions, vous devez{' '}
            <Link style={{color: import.meta.env.VITE_SECONDARY_COLOR}} to={APP_ROUTES.profile}>
              sélectionner un abonnement
            </Link>{' '}
            .
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{width: '100%', justifyContent: 'center'}}>
        <Button variant="outlined" size="large" color="inherit" autoFocus onClick={resetState}>
          Fermer
        </Button>

        {!isPartner ? (
          <Link to={APP_ROUTES.subscription} style={{textDecoration: 'none'}}>
            <Button sx={{ml: 2}} variant="contained" size="large" color="secondary" autoFocus onClick={resetState}>
              Je veux créer plus de connexions
            </Button>
          </Link>
        ) : null}
      </DialogActions>
    </BaseModal>
  );
};

export default MaximumNumberOfProjectsModal;
